import { useState, useCallback } from 'react';
import { pickDriveFiles, isDriveConfigured } from '../lib/googleDrive';

/**
 * React wrapper around the Google Drive connector. Exposes a `pick()` that
 * opens the Drive Picker and resolves to the downloaded CV `File[]`, with
 * loading/progress/error state for the UI.
 */
export const useGoogleDrive = () => {
  const [isPicking, setIsPicking] = useState(false);
  const [progress, setProgress] = useState<{ current: number; total: number } | null>(null);
  const [error, setError] = useState<string | null>(null);

  const pick = useCallback(async (): Promise<File[]> => {
    setError(null);
    setIsPicking(true);
    setProgress(null);
    try {
      return await pickDriveFiles((current, total) => setProgress({ current, total }));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur lors de la connexion à Google Drive.');
      return [];
    } finally {
      setIsPicking(false);
      setProgress(null);
    }
  }, []);

  return { pick, isPicking, progress, error, configured: isDriveConfigured() };
};
